import campaignHistoryTemplate from './campaignHistory.html';

const campaignHistory = {
    bindings: {
        contactId: '@',
        isCustomerContact: '@',
        reloadMethod: '=?',
        contact: '=?',
    },
    template: campaignHistoryTemplate,
    controller: function ($scope, ApiContacts, ApiPicklist, $state) {
        this.moreCampaigns = false;
        this.filter = {
            isCustomerContact: undefined,
            firstQueryResult: undefined,
        };
        this.$onInit = () => {
            ApiPicklist.retrieveLevelsOfInterest().then((response) => {
                this.lol = response.data;
            });
            this.filter.isCustomerContact = this.isCustomerContact;
            this.getCampaignHistory(this.filter);
        };

        this.getCampaignHistory = (filter) => {
            this.campaignloading = true;
            ApiContacts.getContactCampaigns(this.contactId, filter).then(
                (campaigns) => {
                    this.campaigns = campaigns || [];
                    if (this.campaigns.length < 5) {
                        this.moreCampaigns = false;
                    } else {
                        this.moreCampaigns = true;
                    }
                    this.campaignloading = false;
                }
            );
        };

        this.getMoreCampaignHistory = () => {
            this.campaignloading = true;
            this.filter.firstQueryResult = this.campaigns.length;
            this.getContactCampaigns(this.contactId, this.filter).then(
                (campaigns) => {
                    if (!campaigns) {
                        this.moreCampaigns = false;
                    } else {
                        this.moreCampaigns =
                            campaigns.length < 5 ? false : true;
                        this.campaigns = this.campaigns.concat(campaigns);
                        $scope.$broadcast('scroll.infiniteScrollComplete');
                    }
                    this.campaignloading = false;
                }
            );
        };

        this.getContactCampaigns = (contactId, filter) => {
            return ApiContacts.getContactCampaigns(contactId, filter);
        };

        this.reloadMethod = () => {
            this.getCampaignHistory(this.filter);
        };

        this.getCampaignUrl = (campaignId) => {
            return $state.href('campaignDetail', {
                campaignId: campaignId,
                sortOrder: null,
            });
        };

        this.getLoIColor = (loiKey) => {
            let loiItem = this.lol.find((item) => {
                return item.filterKey == loiKey;
            });

            return loiItem ? loiItem.color : '#000';
        };
    },
};

export default campaignHistory;



/** WEBPACK FOOTER **
 ** ./src/app/directives/campaignHistory/campaignHistory.js
 **/